import { render, staticRenderFns } from "./DeRichTextView.vue?vue&type=template&id=f9399fb8&scoped=true&"
import script from "./DeRichTextView.vue?vue&type=script&lang=js&"
export * from "./DeRichTextView.vue?vue&type=script&lang=js&"
import style0 from "./DeRichTextView.vue?vue&type=style&index=0&id=f9399fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9399fb8",
  null
  
)

export default component.exports